import {createSlice, nanoid, PayloadAction} from '@reduxjs/toolkit';

export interface CustomURL {
    id: string;
    name: string;
    date: string;
    url: string;
    target: string;
    showInScene: boolean;
    showInAerial: boolean;
  }

const getByID = (state, linkID: string) => {
  return state.find(url => url.id === linkID);
};

export const customLinkSlice = createSlice({
  name: 'custom_links',
  initialState: [] as CustomURL[],
  reducers: {
    createCustomLink: (state, action: PayloadAction<{
      name: string,
      url: string,
      target: string,
      showInScene: boolean,
      showInAerial: boolean
    }>) => {
      const attributes = action.payload;

      const customURL = {
        id: nanoid(),
        date: new Date().toISOString(),
        ...attributes
      };

      state.push(customURL);
    },
    updateCustomLink: (state, action: PayloadAction<{
      linkID: string,
      name?: string,
      url?: string,
      target?: string,
      showInScene?: boolean,
      showInAerial?: boolean
    }>) => {
      const {linkID, ...updates} = action.payload;

      const customURL = getByID(state, linkID);
      if (!customURL) return;

      for (let key in updates) {
        if (customURL.hasOwnProperty(key)) {
          customURL[key] = updates[key];
        };
      };

      // Update modified date
      customURL.date = new Date().toISOString();
    },
    deleteCustomLink: (state, action: PayloadAction<string>) => {
      return state.filter(url => url.id !== action.payload);
    }
  }
});

export default customLinkSlice.reducer;

export const {
  createCustomLink,
  updateCustomLink,
  deleteCustomLink
} = customLinkSlice.actions;

export const selectAllCustomLinks = state => state.custom_links as CustomURL[];
